import parse from 'html-react-parser';

const useParsedData = (data) => {
  const parsedData = parse(data);
  return parsedData;
};

export default useParsedData;
